import merge from 'lodash.merge';

import sharedScreen from '#frontend/singleDataLayer/shared/screen.js';

/**
 * Billing info (first step)
 * @param {object} cart
 * @returns {object}
 */
export default (cart) => {
	const screen = {
		screen: {
			type: 'purchase',
			section: 'Purchase',
			name: 'ThankYou'
		}
	};

	return merge(screen, sharedScreen(cart));
};
